<template>
  <z-dialogo ref="dialogo" titulo="Finalizar Venda" :dividers="true" largura="1000px" @fechar="fecharClick">
    <template #texto>
      <v-row dense>
        <v-col col="12" sm="3">
          <z-date-picker-menu
            label="Data"
            v-model="pdvStore.pedido.data"
            :disabled="$auth.cant('pedidos:alterar_data') || !configStore.configuracoes.APP_ALTERAR_DATA_VENDA"
            :readonly="$auth.cant('pedidos:alterar_data') || !configStore.configuracoes.APP_ALTERAR_DATA_VENDA"
            filled
            dense
          ></z-date-picker-menu>
        </v-col>

        <v-col cols="12" sm="5">
          <v-autocomplete
            v-model="pdvStore.pedido.cliente_id"
            ref="cliente"
            label="Cliente"
            flat
            filled
            dense
            :items="listasStore.clientes"
            :disabled="pdvStore.pedido.cliente_nome.length > 0"
            ></v-autocomplete>
          </v-col>
          
          <v-col cols="12" sm="4">
            <v-text-field
            v-model="pdvStore.pedido.cliente_nome"
            ref="cliente"
            label="Cliente Avulso"
            flat
            filled
            dense
            autofocus
          ></v-text-field>
        </v-col>

        <v-col cols="12" sm="6">
          <v-autocomplete
            ref="vendedor"
            v-model="pdvStore.pedido.vendedor_id"
            label="Vendedor"
            flat
            filled
            dense
            :items="listasStore.vendedores"
          ></v-autocomplete>
        </v-col>

        <v-col col="12" sm="6">
          <v-autocomplete
            v-model="pdvStore.pedido.forma_pagamento"
            label="Forma de Pagamento"
            :items="$globals.FORMAS_DE_PAGAMENTO"
            filled
            dense
          ></v-autocomplete>
        </v-col>

        <v-col col="12" sm="3">
          <z-campo-valor
            v-model="pdvStore.pedido.valor_bruto"
            ref="valor_bruto"
            label="Valor Bruto"
            filled
            dense
            readonly
            disabled
            :decimais="2"
          ></z-campo-valor>
        </v-col>

        <v-col col="12" sm="3">
          <z-campo-valor
            v-model="pdvStore.pedido.desconto_valor"
            ref="desconto"
            label="Desconto"
            filled
            dense
            :decimais="2"
            @input="pdvStore.calcularTotais"
          ></z-campo-valor>
        </v-col>

        <v-col col="12" sm="3">
          <z-campo-valor
            v-model="pdvStore.pedido.taxa_valor"
            ref="acréscimo"
            label="Acréscimo"
            filled
            dense
            hide-details
            :decimais="2"
            @input="pdvStore.calcularTotais"
          ></z-campo-valor>
        </v-col>
        <v-col col="12" sm="3">
          <z-campo-valor
            v-model="pdvStore.pedido.valor_liquido"
            ref="liquido"
            label="Valor Líquido"
            filled
            dense
            hide-details
            readonly
            disabled
            :decimais="2"
          ></z-campo-valor>
        </v-col>
      </v-row>

    </template>

    <template #actions_right>
      <v-btn depressed block rounded color="primary" @click="finalizarVenda" :loading="loading">
        F5 - CONFIRMAR
      </v-btn>
    </template>
  </z-dialogo>
</template>

<script setup>
import { ref, onMounted, computed, getCurrentInstance } from 'vue';
import { usePDVStore } from '@/app/store/pinia/pdv';
import { useConfigStore } from '@/app/store/pinia/configuracoes';
import { useListasStore } from '@/app/store/pinia/listas';
import queryBuilder from '@/app/helpers/QueryBuilder';

const { proxy } = getCurrentInstance();

const props = defineProps({
  relatorio: {
    type: String,
    default: '',
  },
});

const pdvStore = usePDVStore();
const configStore = useConfigStore();
const listasStore = useListasStore();
const dialogo = ref(null);
const loading = ref(false);

onMounted(() => {
  adicionaEventosTeclado();
});

const abrir = async () => {
  dialogo.value.abrir();
  await getListas();

  pdvStore.pedido.forma_pagamento = configStore.configuracoes.FORMA_PAGAMENTO_PADRAO,
  pdvStore.pedido.vendedor_id = proxy.$auth.getUser().vendedor ? proxy.$auth.getUser().vendedor.id : null;
  pdvStore.pedido.cliente_id = configStore.configuracoes.CLIENTE_PADRAO;

  pdvStore.pdvProdutosEventsHandler.disable();
  pdvStore.pdvFinalizacaoEventsHandler.enable();
};

const fechar = () => {
  dialogo.value.fechar();
  desativarEventosTeclado();
};

const fecharClick = () => {
  desativarEventosTeclado();
};

const finalizarVenda = async () => {
  if (pdvStore.pedido.produtos.length == 0) {
    return;
  }

  try {
    loading.value = true;
    const pedido = await pdvStore.finalizarPedido();
    fechar();
  } catch (error) {
    throw error;
  } finally {
    loading.value = false;
  }
};

const getListas = async () => {

  await listasStore.fetchListas([
    queryBuilder()
      .from("Cliente")
      .selectraw("id as value, concat(id, ' - ', razao) as text")
      .orderBy("razao")
      .build(),

    queryBuilder()
      .from("Vendedor")
      .selectraw("id as value, concat(id, ' - ', nome) as text")
      .orderBy("nome")
      .build(),
  ]);
};

const adicionaEventosTeclado = () => {
  pdvStore.pdvFinalizacaoEventsHandler.addKeyEvent("F5", (event) => {
    finalizarVenda();
  });
}

const desativarEventosTeclado = () => {
  pdvStore.pdvFinalizacaoEventsHandler.disable();
  pdvStore.pdvProdutosEventsHandler.enable();
}

defineExpose({
  abrir,
  fechar,
});
</script>

<style scoped></style>
